// extracted by mini-css-extract-plugin
export default {"listWrapper":"styles_listWrapper__K71y6","wrapper":"styles_wrapper__Ulo5d","remove":"styles_remove__hMRXU"};